import { useState } from 'react';

function useFilters(props?: any) {
    const defaultFilters = props || {};
    const [filters, setFilters] = useState<any>(defaultFilters || {});

    const handleChangeFilters = (e: any) => {
        const { name, value, check, type } = e?.target;

        if (!value) {
            let auxFilters = { ...filters };
            delete auxFilters[name];
            setFilters(auxFilters);
        } else {
            setFilters({
                ...filters,
                [name]: check || value
            });
        }
    };

    const clearFilters = (props?: any) => {
        if (props) setFilters({ ...props });
        else setFilters(() => (!!Object.keys(defaultFilters) ? defaultFilters : {}));
    };

    return { filters, setFilters, handleChangeFilters, clearFilters };
}

export default useFilters;
